export default "__VITE_ASSET__CSDd_XT4__"